import { expoClient } from "@better-auth/expo/client";
import { emailOTPClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import Constants from 'expo-constants';
import { authStorage } from '@/utils/auth-storage';
import { ENV } from '@/config/env';

// Get auth URL from centralized env config (works for web builds)
const AUTH_BASE_URL = ENV.AUTH_URL;
// Get scheme from app config (flavrly-dev, flavrly-prev, or flavrly)
const schemeValue = Constants.expoConfig?.scheme;
const SCHEME = Array.isArray(schemeValue) ? schemeValue[0] : (schemeValue || 'flavrly-dev');

export const authClient = createAuthClient({
    baseURL: AUTH_BASE_URL,
    sessionOptions: {
        refetchOnWindowFocus: false,
    },
    plugins: [
        emailOTPClient(),
        expoClient({
            scheme: SCHEME,
            storagePrefix: "flavrly",
            storage: authStorage,
        })
    ]
});
